module.exports = __webpack_public_path__ + "static/media/a1.d8079463.jpg";